
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function NewYorkAttractions() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-yellow-600 to-orange-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              10 địa điểm không thể bỏ lỡ ở New York
            </h1>
            <p className="text-xl text-yellow-100 mb-8 max-w-3xl mx-auto">
              Khám phá những điểm đến iconic nhất của thành phố không bao giờ ngủ
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Điểm đến New York</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Introduction */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 mb-12">
            <p className="text-lg leading-relaxed text-gray-700 mb-0">
              New York City là thành phố sôi động nhất nước Mỹ với vô số điểm tham quan nổi tiếng thế giới. 
              Từ những tòa nhà chọc trời iconic đến các bảo tàng đẳng cấp, từ công viên xanh mát đến khu mua sắm sầm uất, 
              NYC mang đến trải nghiệm không thể quên cho mọi du khách.
            </p>
          </div>

          {/* Top 10 Attractions */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">🗽 Top 10 Must-Visit Destinations</h2>

            {/* 1. Statue of Liberty */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-blue-600">1</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-government-line text-blue-600"></i>
                    Tượng Nữ thần Tự do (Statue of Liberty)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Biểu tượng của tự do và dân chủ, món quà từ nước Pháp năm 1886. 
                        Tượng cao 93m trên đảo Liberty, accessible bằng ferry từ Battery Park hoặc Liberty State Park.
                      </p>
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-semibold text-blue-900 mb-2">📍 Thông tin thực tế:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Giá vé:</strong> $24.50 (Crown access: $24.50)</li>
                          <li>• <strong>Thời gian:</strong> 9:30AM - 5:00PM</li>
                          <li>• <strong>Ferry:</strong> 30 phút từ Battery Park</li>
                          <li>• <strong>Đặt trước:</strong> Crown tickets sold out months ahead</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">💡 Insider Tips:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• Book crown tickets 3-4 months trước</li>
                        <li>• Pedestal access có view tốt, ít crowded</li>
                        <li>• Combo với Ellis Island</li>
                        <li>• Mang ID để security check</li>
                        <li>• Staten Island Ferry xem free (xa hơn)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 2. Empire State Building */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-orange-600">2</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-building-line text-orange-600"></i>
                    Tòa nhà Empire State
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Tòa nhà Art Deco nổi tiếng nhất thế giới, cao 443m với 102 tầng. 
                        Observatory tầng 86 và 102 mang đến panoramic view 360° của Manhattan.
                      </p>
                      <div className="bg-orange-50 rounded-lg p-4">
                        <h4 className="font-semibold text-orange-900 mb-2">📍 Thông tin chi tiết:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Giá vé:</strong> $42 (86th) / $77 (86th + 102nd)</li>
                          <li>• <strong>Giờ mở:</strong> 9AM - 2AM (last elevator 1:15AM)</li>
                          <li>• <strong>Địa chỉ:</strong> 350 5th Ave, Midtown</li>
                          <li>• <strong>Express pass:</strong> +$40 skip lines</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🌆 Best Times:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Sunset:</strong> 1 giờ trước golden hour</li>
                        <li>• <strong>Clear days:</strong> Check weather trước</li>
                        <li>• <strong>Night:</strong> City lights spectacular</li>
                        <li>• <strong>Avoid:</strong> Weekends, holidays</li>
                        <li>• <strong>Lightning show:</strong> Tòa nhà thay đổi màu</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Times Square */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-red-600">3</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-flashlight-line text-red-600"></i>
                    Quảng trường Thời đại (Times Square)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        "Crossroads of the World" - trung tâm sầm uất với billboards khổng lồ, 
                        Broadway theaters, shopping và street performers. Must-see về đêm khi đèn neon rực rỡ.
                      </p>
                      <div className="bg-red-50 rounded-lg p-4">
                        <h4 className="font-semibold text-red-900 mb-2">🎭 Hoạt động nổi bật:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Broadway shows:</strong> $50-500 tùy chỗ ngồi</li>
                          <li>• <strong>Red Steps:</strong> TKTS stairs view miễn phí</li>
                          <li>• <strong>M&M Store:</strong> 3 tầng chocolate heaven</li>
                          <li>• <strong>Street performers:</strong> Naked Cowboy, characters</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">⚠️ Survival Tips:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• Cực kỳ crowded, giữ đồ đạc cẩn thận</li>
                        <li>• Street performers: tip tự nguyện</li>
                        <li>• Character photos: Thương lượng giá trước</li>
                        <li>• Restaurants: Overpriced, ăn gần đó</li>
                        <li>• Best photos: 7th Ave & Broadway intersection</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 4. Central Park */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-green-600">4</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-tree-line text-green-600"></i>
                    Công viên Trung tâm (Central Park)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Oasis xanh 843 acres giữa lòng Manhattan. Thiết kế bởi Frederick Law Olmsted, 
                        có lakes, meadows, walking paths và nhiều iconic landmarks.
                      </p>
                      <div className="bg-green-50 rounded-lg p-4">
                        <h4 className="font-semibold text-green-900 mb-2">🌳 Must-see spots:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Bethesda Fountain:</strong> Iconic centerpiece</li>
                          <li>• <strong>Bow Bridge:</strong> Most romantic spot</li>
                          <li>• <strong>Strawberry Fields:</strong> John Lennon memorial</li>
                          <li>• <strong>Mall:</strong> Tree-lined promenade</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🚴 Activities:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Bike rental:</strong> $15/hour, $40/day</li>
                        <li>• <strong>Horse carriage:</strong> $120 30min ride</li>
                        <li>• <strong>Boat rental:</strong> $20/hour Loeb Boathouse</li>
                        <li>• <strong>Zoo:</strong> $18 adults, great for families</li>
                        <li>• <strong>Free concerts:</strong> Summer series</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 5. Brooklyn Bridge */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-purple-600">5</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-road-map-line text-purple-600"></i>
                    Cầu Brooklyn
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Cây cầu treo đầu tiên thế giới (1883), kết nối Manhattan và Brooklyn. 
                        Promenade dành riêng cho pedestrian với spectacular views của skyline và harbor.
                      </p>
                      <div className="bg-purple-50 rounded-lg p-4">
                        <h4 className="font-semibold text-purple-900 mb-2">📸 Photography spots:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Center span:</strong> Best skyline view</li>
                          <li>• <strong>Brooklyn side:</strong> Full bridge + skyline</li>
                          <li>• <strong>DUMBO:</strong> Bridge framed by buildings</li>
                          <li>• <strong>Manhattan side:</strong> FDR Drive entrance</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🚶 Walking tips:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Distance:</strong> 1.1 miles (25-30 phút)</li>
                        <li>• <strong>Best time:</strong> Early morning ít đông</li>
                        <li>• <strong>Sunset:</strong> Amazing nhưng crowded</li>
                        <li>• <strong>Stay right:</strong> Left lane for bikers</li>
                        <li>• <strong>After walk:</strong> Brooklyn Bridge Park</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 6. 9/11 Memorial */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-gray-600">6</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-memorial-line text-gray-600"></i>
                    Đài tưởng niệm 9/11
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Khu tưởng niệm trang nghiêm tại Ground Zero, nơi từng là Twin Towers. 
                        Reflecting pools với tên của 2,977 victims và museum cảm động về sự kiện 9/11.
                      </p>
                      <div className="bg-gray-50 rounded-lg p-4">
                        <h4 className="font-semibold text-gray-900 mb-2">🕊️ Khu memorial:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Twin pools:</strong> Miễn phí, mở 24/7</li>
                          <li>• <strong>Names arrangement:</strong> Meaningful clusters</li>
                          <li>• <strong>Survivor Tree:</strong> Callery pear tree symbol</li>
                          <li>• <strong>Museum:</strong> $29, powerful exhibits</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-blue-50 rounded-lg p-4">
                      <h4 className="font-semibold text-blue-900 mb-2">ℹ️ Visiting info:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Free memorial:</strong> No tickets needed</li>
                        <li>• <strong>Museum tickets:</strong> Timed entry advance book</li>
                        <li>• <strong>Security check:</strong> Airport-style screening</li>
                        <li>• <strong>Respectful attire:</strong> Solemn environment</li>
                        <li>• <strong>Audio guide:</strong> $7 recommended</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 7. High Line */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-teal-600">7</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-train-line text-teal-600"></i>
                    Công viên High Line
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Công viên tuyến tính unique trên đường sắt cũ elevated, dài 1.45 miles từ Meatpacking District đến Hudson Yards. 
                        Art installations, gardens và Hudson River views.
                      </p>
                      <div className="bg-teal-50 rounded-lg p-4">
                        <h4 className="font-semibold text-teal-900 mb-2">🎨 Highlights:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Whitney Museum:</strong> Art contemporary</li>
                          <li>• <strong>Chelsea Market:</strong> Food hall dưới High Line</li>
                          <li>• <strong>Hudson Yards:</strong> Vessel & Edge observation</li>
                          <li>• <strong>Wildflowers:</strong> Native plants landscape</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🚶 Walking guide:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Length:</strong> 1.45 miles end to end</li>
                        <li>• <strong>Time:</strong> 45 phút leisurely walk</li>
                        <li>• <strong>Entry points:</strong> Multiple access stairs</li>
                        <li>• <strong>Best direction:</strong> South to North</li>
                        <li>• <strong>Busy times:</strong> Weekends + afternoons</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 8. One World Observatory */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-blue-600">8</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-skyscraper-line text-blue-600"></i>
                    Đài quan sát One World Observatory
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Tầng 100-102 của One World Trade Center (Freedom Tower), cao nhất Western Hemisphere. 
                        360° views của NYC, innovative exhibits và Sky Portal glass platform.
                      </p>
                      <div className="bg-blue-50 rounded-lg p-4">
                        <h4 className="font-semibold text-blue-900 mb-2">🌟 Experience:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Sky Portal:</strong> Glass floor view down</li>
                          <li>• <strong>Time-lapse elevators:</strong> 47 giây lên tầng 102</li>
                          <li>• <strong>City Pulse:</strong> Interactive city guides</li>
                          <li>• <strong>Champlain Terrace:</strong> Outdoor space</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">💰 Pricing & timing:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Standard:</strong> $39-47 tùy thời điểm</li>
                        <li>• <strong>Priority access:</strong> +$20 skip lines</li>
                        <li>• <strong>Best views:</strong> Clear day mornings</li>
                        <li>• <strong>Sunset:</strong> Premium pricing nhưng worth it</li>
                        <li>• <strong>Combined:</strong> With 9/11 Memorial tickets</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 9. Metropolitan Museum */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-pink-600">9</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-ancient-pavilion-line text-pink-600"></i>
                    Bảo tàng Nghệ thuật Metropolitan
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Bảo tàng nghệ thuật lớn nhất nước Mỹ với 2 triệu pieces từ ancient đến contemporary. 
                        Egyptian art, European paintings, Arms & Armor và rooftop garden với Central Park views.
                      </p>
                      <div className="bg-pink-50 rounded-lg p-4">
                        <h4 className="font-semibold text-pink-900 mb-2">🎨 Must-see collections:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Egyptian Art:</strong> Temple of Dendur</li>
                          <li>• <strong>European Paintings:</strong> Van Gogh, Monet</li>
                          <li>• <strong>American Wing:</strong> US art history</li>
                          <li>• <strong>Rooftop Garden:</strong> Seasonal installations</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">🎫 Visit strategy:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Suggested admission:</strong> $30 (pay what you wish NYC residents)</li>
                        <li>• <strong>Time needed:</strong> 3-4 giờ minimum</li>
                        <li>• <strong>Free audio guide:</strong> Bloomberg Connects app</li>
                        <li>• <strong>Less crowded:</strong> Weekday mornings</li>
                        <li>• <strong>Gallery talks:</strong> Free daily tours</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 10. Top of the Rock */}
            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-8 shadow-sm">
              <div className="flex items-start gap-6">
                <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-2xl font-bold text-yellow-600">10</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <i className="ri-camera-2-line text-yellow-600"></i>
                    Đài quan sát Top of the Rock
                  </h3>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Observation deck tại Rockefeller Center với best views của Empire State Building và Central Park. 
                        3 tầng outdoor terraces (tầng 67, 69, 70) và less crowded than Empire State.
                      </p>
                      <div className="bg-yellow-50 rounded-lg p-4">
                        <h4 className="font-semibold text-yellow-900 mb-2">📸 Photography paradise:</h4>
                        <ul className="text-sm space-y-1">
                          <li>• <strong>Empire State Building:</strong> Perfect framing</li>
                          <li>• <strong>Central Park:</strong> Bird's eye rectangular view</li>
                          <li>• <strong>Christmas:</strong> Rockefeller tree từ trên cao</li>
                          <li>• <strong>Multiple levels:</strong> Different vantage points</li>
                        </ul>
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <h4 className="font-semibold text-gray-800 mb-2">⭐ Why better:</h4>
                      <ul className="text-sm space-y-1">
                        <li>• <strong>Empire State views:</strong> Can't see from Empire State itself</li>
                        <li>• <strong>Faster elevators:</strong> Less waiting time</li>
                        <li>• <strong>Outdoor terraces:</strong> No glass barriers</li>
                        <li>• <strong>Timed tickets:</strong> Less crowded experience</li>
                        <li>• <strong>Price:</strong> $39 vs $42 Empire State</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Lịch trình gợi ý */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">📅 Lịch trình gợi ý 3-5 ngày</h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8">
                <h3 className="text-xl font-bold text-blue-900 mb-6">🗓️ Lịch trình 3 ngày cơ bản</h3>
                <div className="space-y-6">
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-bold text-blue-800 mb-2">Ngày 1: Midtown Manhattan</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Sáng: Empire State Building</li>
                      <li>• Trưa: Times Square + Broadway</li>
                      <li>• Chiều: Top of the Rock sunset</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-bold text-blue-800 mb-2">Ngày 2: Downtown + Harbor</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Sáng: 9/11 Memorial + Museum</li>
                      <li>• Trưa: Ferry to Statue of Liberty</li>
                      <li>• Chiều: Brooklyn Bridge walk</li>
                    </ul>
                  </div>
                  <div className="bg-white rounded-lg p-4">
                    <h4 className="font-bold text-blue-800 mb-2">Ngày 3: Culture + Parks</h4>
                    <ul className="text-sm space-y-1">
                      <li>• Sáng: Metropolitan Museum</li>
                      <li>• Trưa: Central Park picnic</li>
                      <li>• Chiều: High Line + Chelsea</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-pink-100 rounded-xl p-8">
                <h3 className="text-xl font-bold text-purple-900 mb-6">🗓️ Lịch trình 5 ngày comprehensive</h3>
                <div className="space-y-4">
                  <div className="bg-white rounded-lg p-3">
                    <h4 className="font-bold text-purple-800 text-sm mb-1">Ngày 1-2:</h4>
                    <p className="text-xs">Essential Manhattan (như trên)</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <h4 className="font-bold text-purple-800 text-sm mb-1">Ngày 3: Brooklyn</h4>
                    <p className="text-xs">DUMBO, Brooklyn Bridge Park, Williamsburg</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <h4 className="font-bold text-purple-800 text-sm mb-1">Ngày 4: Museums</h4>
                    <p className="text-xs">MoMA, Guggenheim, American Museum Natural History</p>
                  </div>
                  <div className="bg-white rounded-lg p-3">
                    <h4 className="font-bold text-purple-800 text-sm mb-1">Ngày 5: Neighborhoods</h4>
                    <p className="text-xs">SoHo, Greenwich Village, Little Italy, Chinatown</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Practical tips */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">💡 Tips thực tế cho NYC</h2>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4 flex items-center gap-2">
                  <i className="ri-subway-line"></i>
                  Di chuyển
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>MetroCard:</strong> $33/7 ngày unlimited</li>
                  <li>• <strong>Walking:</strong> Nhanh hơn taxi trong rush hour</li>
                  <li>• <strong>Uber/Lyft:</strong> Surge pricing peak times</li>
                  <li>• <strong>Taxi:</strong> Yellow cabs accept cards</li>
                  <li>• <strong>Citi Bike:</strong> $15/day bike sharing</li>
                </ul>
              </div>

              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4 flex items-center gap-2">
                  <i className="ri-restaurant-2-line"></i>
                  Ăn uống
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>Pizza:</strong> $1 slice at 99¢ Fresh Pizza</li>
                  <li>• <strong>Food trucks:</strong> $8-12 authentic meals</li>
                  <li>• <strong>Delis:</strong> Breakfast sandwich $4-7</li>
                  <li>• <strong>Happy hour:</strong> 4-7PM discounted drinks</li>
                  <li>• <strong>Tipping:</strong> 20% restaurants, 15% casual</li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4 flex items-center gap-2">
                  <i className="ri-money-dollar-circle-line"></i>
                  Tiết kiệm tiền
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>• <strong>CityPASS:</strong> $132 save 40% on 6 attractions</li>
                  <li>• <strong>Free events:</strong> Central Park concerts</li>
                  <li>• <strong>Happy hours:</strong> Drinks + apps deals</li>
                  <li>• <strong>Brooklyn:</strong> Cheaper eats + drinks</li>
                  <li>• <strong>Walking tours:</strong> $20-25 tips-based</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Seasonal considerations */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">🌤️ Thời điểm tốt nhất visit NYC</h2>
              <div className="grid md:grid-cols-4 gap-4">
                <div className="text-center">
                  <div className="text-3xl mb-2">🌸</div>
                  <h3 className="font-bold mb-2">Xuân (3-5)</h3>
                  <p className="text-sm text-indigo-100">Mild weather, fewer crowds, Central Park blooms</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl mb-2">☀️</div>
                  <h3 className="font-bold mb-2">Hè (6-8)</h3>
                  <p className="text-sm text-indigo-100">Outdoor events, long days, hot humid weather</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl mb-2">🍂</div>
                  <h3 className="font-bold mb-2">Thu (9-11)</h3>
                  <p className="text-sm text-indigo-100">Perfect weather, fall foliage, fashion week</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl mb-2">❄️</div>
                  <h3 className="font-bold mb-2">Đông (12-2)</h3>
                  <p className="text-sm text-indigo-100">Christmas magic, ice skating, cold but beautiful</p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-yellow-500 to-orange-500 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Sẵn sàng khám phá Big Apple?</h3>
            <p className="mb-6 text-yellow-100">
              Chúng tôi sẽ giúp bạn lập lịch trình tối ưu cho chuyến đi NYC!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-orange-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn lịch trình NYC
              </button>
              <button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Tải map NYC offline
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
